import { Challenge } from "@/types/challenge";
import { funifierApi } from "./api";

export async function getChallenges() {
  try {
    const { data } = await funifierApi.get("/challenge");
    if (Array.isArray(data)) {
      return data as Challenge[];
    }
  } catch (err) {
    return [];
  }
}
